import { render, staticRenderFns } from "./HomeBlocknote.vue?vue&type=template&id=437064b5&scoped=true"
import script from "./HomeBlocknote.vue?vue&type=script&lang=js"
export * from "./HomeBlocknote.vue?vue&type=script&lang=js"
import style0 from "./HomeBlocknote.vue?vue&type=style&index=0&id=437064b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437064b5",
  null
  
)

export default component.exports